import { render, staticRenderFns } from "./AddCluster.vue?vue&type=template&id=1ed51f9f&scoped=true&"
import script from "./AddCluster.vue?vue&type=script&lang=js&"
export * from "./AddCluster.vue?vue&type=script&lang=js&"
import style0 from "./AddCluster.vue?vue&type=style&index=0&id=1ed51f9f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ed51f9f",
  null
  
)

export default component.exports